export default function jobsSingleTemplate() {
	const wrappers = document.querySelectorAll('[data-js="content-tabs"]');

	wrappers.forEach(function (wrapper) {
		const tabs = wrapper.querySelectorAll('[data-tab]');
		const root =
			wrapper.closest('.account-page-subscriptions') ||
			wrapper.closest('.main-wrapper') ||
			wrapper.closest('.container') ||
			document;
		const panels = root.querySelectorAll('.panels [data-panel]');

		if (!tabs.length || !panels.length) return;

		const setActive = function (key) {
			tabs.forEach(function (t) {
				const isActive = t.getAttribute('data-tab') === key;
				t.classList.toggle('is-active', isActive);
				t.setAttribute('aria-selected', String(isActive));
				t.setAttribute('tabindex', isActive ? '0' : '-1');
			});

			panels.forEach(function (panel) {
				const isActive = panel.getAttribute('data-panel') === key;
				panel.classList.toggle('is-active', isActive);
				panel.hidden = !isActive;
				panel.setAttribute('aria-hidden', String(!isActive));
			});
		};

		const firstKey = (wrapper.querySelector('.tab.is-active') || tabs[0])?.getAttribute('data-tab');
		if (firstKey) setActive(firstKey);

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				const key = tab.getAttribute('data-tab');
				if (!key) return;
				setActive(key);

				// Reflect the active tab in the URL (?tab=...) so the address bar
				// stays copy/shareable and a reload lands back on the same tab.
				// replaceState, not pushState: switching tabs shouldn't add
				// Back-button stops.
				if (window.history && window.history.replaceState) {
					const url = new URL(window.location.href);
					url.searchParams.set('tab', key);
					window.history.replaceState(window.history.state, '', url);
				}
			});
		});
	});
}
